import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { MailCheck } from "lucide-react";
import { useI18n } from "@/i18n";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-th-blue th-pattern py-16 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-6"><Logo size={54} className="mx-auto" />
          <h1 className="mt-4 font-display font-bold text-2xl text-th-blue">{t("fp_title")}</h1></div>
        {sent ? (
          <div className="text-center" data-testid="fp-sent">
            <MailCheck className="w-12 h-12 text-th-gold mx-auto mb-4" />
            <p className="text-slate-600">{t("fp_sent")}</p>
            <Link to="/entrar" className="inline-block mt-6 text-th-blue font-semibold hover:text-th-gold" data-testid="fp-back">{t("fp_back")}</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <p className="text-sm text-slate-500">{t("fp_desc")}</p>
            <div><Label>{t("form_email")}</Label>
              <Input required type="email" value={email} data-testid="fp-email" onChange={(e) => setEmail(e.target.value)} className="mt-1" /></div>
            {error && <div className="text-red-600 text-sm bg-red-50 rounded p-2" data-testid="fp-error">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="fp-submit" className="w-full bg-th-blue text-white hover:bg-th-bluelight h-11">{loading ? t("loading") : t("fp_submit")}</Button>
            <p className="text-center text-sm"><Link to="/entrar" className="text-th-blue font-semibold hover:text-th-gold" data-testid="fp-back-link">{t("fp_back")}</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
